import React, { createContext, useContext, useState, useEffect } from "react";

const ThemeContext = createContext();

const THEMES = [
  { id: "selise", label: "SELISE" },
  { id: "current", label: "Classic" },
  { id: "dark", label: "Dark" },
];

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(
    () => localStorage.getItem("orgTheme") || "selise"
  );

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    localStorage.setItem("orgTheme", theme);
  }, [theme]);

  return (
    <ThemeContext.Provider value={{ theme, setTheme, themes: THEMES }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  return useContext(ThemeContext);
}